// // /pages/FleetManagement/Helpers/AddHelperPage.tsx
// import React from 'react';
// import { Box, Card, CardBody } from '@chakra-ui/react';
// import { useNavigate } from 'react-router-dom';
// import { AdminLayout } from '@/components/layout/AdminLayout';
// import { HelperForm } from '@/components/forms/HelperForm';

// const AddHelperPage = () => {
//     const navigate = useNavigate();
//     const handleBack = () => navigate('/fleet-management/helpers');

//     return (
//         <AdminLayout>
//             <Box p={6}>
//                 <Card variant="outline">
//                     <CardBody>
//                         <HelperForm 
//                             onSuccess={handleBack} 
//                             onCancel={handleBack} 
//                         />
//                     </CardBody>
//                 </Card>
//             </Box>
//         </AdminLayout>
//     );
// };

// export default AddHelperPage;


// /pages/FleetManagement/Helpers/AddHelperPage.tsx
import React from 'react';
import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { HelperForm } from '@/components/forms/HelperForm';

const AddHelperPage = () => {
    const navigate = useNavigate();
    const handleBack = () => navigate('/fleet-management/helpers');

    return (
        <AdminLayout>
            {/* 1. Container: Forced full height, hidden overflow, flex column */}
            <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
                
                {/* 2. Card: h="full" and flex column to partition header and body */}
                <Card h="full" display="flex" flexDirection="column" variant="outline" boxShadow="sm">
                    
                    {/* 3. Header: Fixed at the top, stays visible on shrink */}
                    <CardHeader py={4} borderBottom="1px" borderColor="gray.100" flexShrink={0}>
                        <Heading size="md" mb={1}>Add New Helper</Heading>
                        <Text fontSize="sm" color="gray.500">
                            Register a new truck helper to the fleet.
                        </Text>
                    </CardHeader>
                    
                    {/* 4. Body: Only this section scrolls (overflowY="auto") */}
                    <CardBody py={6} overflowY="auto" flex="1" minH={0}>
                        <HelperForm 
                            onSuccess={handleBack} 
                            onCancel={handleBack} 
                        />
                    </CardBody>
                </Card>
            </Box>
        </AdminLayout>
    );
};

export default AddHelperPage;